import { DecimalPipe, DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { TableApiCredentialsService } from './table-api-credentials.service';
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { finalize, Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-table-api-credentials',
  templateUrl: './table-api-credentials.component.html',
  styleUrls: ['./table-api-credentials.component.scss'],
  providers: [TableApiCredentialsService, DecimalPipe, DatePipe]
})

export class TableApiCredentials {
  public dataInitial!: NgbDateStruct;
  public dataFinal!: NgbDateStruct;
  public transactionType: string = '';
  public selectedStatus: string = '';
  public selectedOrigin: string = '';
  public selectedApplciation: string = '';
  public personName: string = '';
  public searchType: string = '';
  public page: number = 1;
  public pageSize: number = 20;
  public total: number = 0;
  public receiptTemplate: string = '';
  public bankProvider: Array<any> = [];
  public nameColumn: string = '';
  public account: any;
  public accounts: Array<any> = [];
  public selectedTransaction: any;
  public selectedCrypto: any = null;
  public canDownloadReceipt = false;
  public canResendWebhook = false;
  public isReprocessing = false;
  public tableRowForReceipt: any = null;
  public switchingId: string | null = null;
  public selectedAccount: any = null;
  public updatingId: string | null = null;
  public selectedUser: any = null;
  public validationCode: string = '';
  public validatingTotp: boolean = false;
  public errorMessage: string = '';
  public pendingUser: any = null;
  public pendingSwitchAccountId: string | null = null;
  public isLoaded = true;
  langChangeSub!: Subscription;

  @ViewChild('requestTOTPCode') validateToken!: ElementRef | any;
  @Output() loading = new EventEmitter<boolean>();
  @Output() switched = new EventEmitter<void>();
  @Output() statusChanged = new EventEmitter<void>();


  constructor(
    private tableApiCredentialsService: TableApiCredentialsService,
    private toastr: ToastrService,
    private modal: NgbModal,
    private auth: AuthService) {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());

    this.dataInitial = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() }
    this.dataFinal = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() }
    this.selectedStatus = 'REALIZADO';
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading.emit(true);

    this.tableApiCredentialsService
      .getAccountMulti()
      .subscribe({
        next: (body: any) => {
          this.accounts = body?.getAccountKeyOriginResponse ?? [];
          console.log(this.accounts)
        },
        error: () => {
          this.accounts = [];
          this.total = 0;
        },
        complete: () => {
          this.loading.emit(false);
        }
      });
  }


  private openTotpModal() {
    this.modal.open(this.validateToken, {
      backdrop: 'static',
      keyboard: true,
      centered: true,
      size: 'sm',
    });
  }


  async pasteTotpCode() {
    try {
      const text = await navigator.clipboard.readText();
      this.validationCode = (text || '').trim();
    } catch {
      this.toastr.error('Erro ao colar o código do clipboard');
    }
  }


  async validateTotp() {
    if (this.validatingTotp) return;
    this.validatingTotp = true;
    this.errorMessage = '';

    try {
      const res = await this.auth.validateTotpCode(this.validationCode);
      const isValid = !!res?.isValid;

      if (isValid) {
        this.modal.dismissAll();

        if (this.pendingSwitchAccountId) {
          await this.doSwitchAccount(this.pendingSwitchAccountId);
          this.pendingSwitchAccountId = null;
        }

        this.validationCode = '';
      } else {
        this.errorMessage = 'Código de autenticação inválido!';
      }
    } catch {
      this.errorMessage = 'Falha ao validar o código de autenticação.';
    } finally {
      this.validatingTotp = false;
    }
  }


  private async doSwitchAccount(accountId: string) {
    this.switchingId = accountId;

    return new Promise<void>((resolve) => {
      this.tableApiCredentialsService
        .switchAccount(accountId)
        .pipe(
          finalize(() => {
            this.switchingId = null;
            this.pendingSwitchAccountId = null;
          })
        )
        .subscribe({
          next: () => {
            this.toastr.success('Conta operacional alterada com sucesso.');
            this.page = 1;
            this.loadData();
            this.switched.emit();
            resolve();
          },
          error: () => {
            this.toastr.error('Falha ao trocar conta operacional.');
            resolve();
          }
        });
    });
  }

  onSwitchAccount(accountId: string) {
    if (this.switchingId) return;

    this.pendingSwitchAccountId = accountId;
    this.validationCode = '';
    this.errorMessage = '';

    this.openTotpModal();
  }
}


